import { useCallback, useMemo } from "react"
import { useReadContract } from "wagmi"

import { PoolFactory } from "#/shared/constants/artifacts"
import { SwappableToken } from "#/shared/types"
import { isStablePool, multiplyBigIntWithDecimal } from "#/shared/utils"

import useSwapPool from "./useSwapPool"

const useSwapFee = (tokenIn: SwappableToken, tokenOut: SwappableToken) => {
  const { data: swapPool } = useSwapPool(tokenIn, tokenOut)

  const swapFeeQuery = useReadContract({
    abi: PoolFactory.abi,
    address: PoolFactory.address,
    functionName: "getFee",
    args: [swapPool, isStablePool(tokenIn, tokenOut)],
    query: { enabled: !!swapPool },
  })

  const { data: swapFee } = swapFeeQuery

  const swapFeePercentage = useMemo(
    () => (swapFee ? Number(swapFee as bigint) / 100 : 0),
    [swapFee],
  )

  const getSwapFeeAmount = useCallback(
    (amount: bigint) =>
      swapFeePercentage
        ? multiplyBigIntWithDecimal(amount, swapFeePercentage / 100)
        : 0n,
    [swapFeePercentage],
  )

  return { ...swapFeeQuery, getSwapFeeAmount, swapFeePercentage }
}

export default useSwapFee
